<template>
  <div class="changelog person_picture">
    <div>
      <div v-for="(lval, lkey) in log" :key="lkey">
        <span class="user">{{ user(lval.user_id) }} - {{ time(lval.created_at) }}</span>
        <table>
          <tbody>
              <tr>
                <td><img :src="'https://fileserver.documedias.systems/file/' + lval.picture" style="width: 240px; height: 240px;" /></td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      users: [],
      log: [],
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      return (this.users && this.users[id]) ? this.users[id] : 'System';
    },
  },
  async created() {
    dayjs.extend(utc);
    const log = await this.axios.get(API_URL + '/logs/persons/' + this.$route.params.id + '/picture');
    this.users = log.data.users;
    this.log = log.data.log;
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.changelog.person_picture {
  position: absolute;
  top: 0;
  right: 0;
  width: 680px;
  height: 100%;
  opacity: .95;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    overflow-y: scroll;
    > div {
      padding: 12px;
      &:not(:first-child) {
        border-top: 1px solid lighten($primary-color, 80%);
      }
      > span {
        display: inline-block;
        opacity: .4;
        padding-left: 2px;
        margin-bottom: 3px;
        border-bottom: 0;
      }
      > table {
        > tbody {
          > tr {
            > td {
              vertical-align: top;
            }
          }
        }
      }
    }
  }
}
</style>